define('shared/util/dispatchers/publisherFactory',[ './publishers/form', './publishers/state' ], 
function ( form, state ) {
    'use strict';

    var PUBLISHERS = {
        'form': form,
        'state': state
    };

    return {
        create: function ( target ) {

            if ( typeof target.publish == 'function' ) {
                return target.publish;
            }
            else {
                return PUBLISHERS[ target.type ];
            }
            
        }
    };
});
